import React from 'react';
import { Stack } from '@facet-wealth/design';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PropTypes from 'prop-types';

/**
 * Use PageTop component directly instead
 *
 * @deprecated
 */
export default function SurveyStepHeader({
  subtitle,
  title,
  alertTitle,
  alertDescription,
  titleTest,
  subtitleTest,
  textAlign,
}) {
  return <>
    <Stack direction={'column'} spacing={2} justifyContent="flex-start">
      <PageContentTop
        textAlign={textAlign}
        title={title}
        subtitle={subtitle}
        titleTest={titleTest}
        subtitleTest={subtitleTest}
        alertTitle={alertTitle}
        alertDescription={alertDescription}
      />
      <div />
    </Stack>
  </>;
}

SurveyStepHeader.propTypes = {
  textAlign: 'center',
};

SurveyStepHeader.propTypes = {
  textAlign: PropTypes.oneOf(['left', 'center']),
};
